import { render, staticRenderFns } from "./bim.vue?vue&type=template&id=68ece19d&scoped=true&"
import script from "./bim.vue?vue&type=script&lang=js&"
export * from "./bim.vue?vue&type=script&lang=js&"
import style0 from "./bim.vue?vue&type=style&index=0&id=68ece19d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ece19d",
  null
  
)

export default component.exports